<template>
  <tr>
    <slot />
  </tr>
</template>
<script lang = "babel">
  export default{
    name: 'EditableGridRow',

    props: {
      activeRow: Number
    },

    created () {
      this.$on('activated', (data) => {
        this.$parent.$emit('activated', data)
      })

      this.$on('edit', (data) => {
        this.$parent.$emit('edit', data)
      })
    }
  }
</script>



// WEBPACK FOOTER //
// EditableGridRow.vue?479a340b